import Vue from 'vue'
import Vuex from 'vuex'
import mapState from '@/app/model/store/domain/MapState/index'
import fieldState from '@/app/model/store/domain/FieldState/index'
import fieldDetailsState from '@/app/model/store/domain/FieldDetailsState/index'
import graphState from '@/app/model/store/domain/GraphState/index'
import graphToggleState from '@/app/model/store/domain/GraphToggleState/index'
import fieldChoiceState from '@/app/model/store/domain/FieldChoiceState/index'
import accountState from '@/app/model/store/domain/AccountState/index'
import varietyState from '@/app/model/store/domain/VarietyState/index'
import alertState from '@/app/model/store/domain/AlertState/index'
import dateChoiceState from '@/app/model/store/domain/DateChoiceState/index'
import fieldOrderState from '@/app/model/store/domain/FieldOrderState/index'
import stageUpdateState from '@/app/model/store/domain/StageUpdateState/index'
import profitState from '@/app/model/store/domain/ProfitState/index'
import routeState from '@/app/model/store/domain/RouteState/index'
import setFlagState from '@/app/model/store/domain/SetFlagState/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    mapState,
    fieldState,
    fieldDetailsState,
    graphState,
    graphToggleState,
    fieldChoiceState,
    accountState,
    varietyState,
    alertState,
    dateChoiceState,
    fieldOrderState,
    stageUpdateState,
    profitState,
    routeState,
    setFlagState
  }
})
